export default __webpack_public_path__ + "static/media/Imediatista.8c207461.svg";